export default __webpack_public_path__ + "static/media/u3.be6c54e1.jfif";